import { FirmName, LogoUrl } from "@/data/SiteContent";

interface LogoProps {
  Light?: boolean;
}

export function Logo({ Light = true }: LogoProps) {
  if (LogoUrl) {
    return (
      <img
        src={LogoUrl}
        alt={`Logotipo de ${FirmName}`}
        data-testid="header-logo"
        className="h-12 w-auto sm:h-14"
        width={642}
        height={260}
      />
    );
  }
  return (
    <span className="flex items-center gap-3" data-testid="header-logo">
      <span className="flex h-10 w-10 items-center justify-center border border-gold/60 font-serif text-lg text-gold">
        SJ
      </span>
      <span className="leading-tight">
        <span
          className={`block font-serif text-base tracking-wide ${Light ? "text-white" : "text-ink"}`}
        >
          Grupo Jurídico
        </span>
        <span className="block text-[0.65rem] font-medium uppercase tracking-[0.3em] text-gold">
          San Juan
        </span>
      </span>
    </span>
  );
}
